import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from "vue";
import LoadingComponent from "@/components/loadingComponent.vue";
import ErrorComponent from "@/components/errorComponent.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'asyncComponent',
  props: {
  url: String,
  delay: { type: Number, default: 1000 },
  timeout: { type: Number, default: 3000 },
},
  setup(__props, { expose: __expose }) {
  __expose();

const Props = __props;
const loadComponent = defineAsyncComponent({
  loader: () => import(`@/components/${Props.url}`),
  loadingComponent: LoadingComponent /* shows while loading */,
  errorComponent: ErrorComponent /* shows if there's an error */,
  delay: Props.delay /* delay in ms before showing loading component */,
  timeout: Props.timeout /* timeout after this many ms */,
});

const __returned__ = { Props, loadComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})